// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'state' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/**
 * @typedef {Object} Appointment
 * @property {string} id
 * @property {number} createdAt
 * @property {string} createdBy
 * @property {string} organization
 * @property {string} target
 * @property {number} startAt
 * @property {number} endAt
 * @property {number} arrivedAt
 * @property {string} arrivedBy
 * @property {number} cancelledAt
 * @property {string} cancelledBy
 * @property {Object} meta
 */

const state = {
  /** @type {Appointment[]} */
  appointments: []
};

export default state;
